import cn from 'classnames';
import { AppNavLink } from 'shared/UI/UIKit/Link';
import { AppText } from 'shared/UI/UIKit/Text';
import type { MouseEventHandler, ReactNode } from 'react';
import type { Path } from 'react-router-dom';
import type { AppLinkProps } from 'shared/UI/UIKit/Link';
import type { SidebarMenuItem } from '../../types';
import type { AppTextProps } from 'shared/UI/UIKit/Text';
import { getIcon } from './get-icon';
import styles from './styles.module.scss';

type GetLinkItemProps = {
  key: string;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
  isInner?: boolean;
  ellipsis?: AppTextProps['ellipsis'];
  linkProps: AppLinkProps;
  onClick?: (url: string | Partial<Path>) => void;
};

export const getLinkItem = ({
  key,
  label,
  icon,
  disabled,
  className,
  wrapperClassName,
  isInner,
  ellipsis = { tooltip: label },
  linkProps,
  onClick,
}: GetLinkItemProps): SidebarMenuItem => {
  const onWrapperClick: MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation();
  };

  const onLinkClick: AppLinkProps['onClick'] = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }

    onClick?.(linkProps.to);
  };

  return {
    key,
    disabled,
    className: cn(
      styles['item-wrapper'],
      styles['link-item__wrapper'],
      { [styles['link-item__wrapper_inner']]: isInner },
      wrapperClassName,
    ),
    label: (
      <div onClick={onWrapperClick}>
        <AppNavLink
          {...linkProps}
          className={cn(
            styles['link-item__content'],
            { [styles['link-item__content_first-lvl']]: !isInner },
            { [styles['link-item__content_second-lvl']]: isInner },
            className,
          )}
          onClick={onLinkClick}
        >
          <AppText
            size={16}
            disabled={disabled}
            ellipsis={ellipsis}
            className={styles['link-item__title']}
          >
            {icon && <span className={styles['link-item__icon']}>{getIcon(icon)}</span>}
            <span>{label}</span>
          </AppText>
        </AppNavLink>
      </div>
    ),
  };
};
